export default __webpack_public_path__ + "static/media/rotate360.d9b65f22.png";